import { useMutation, useQueryClient } from "@tanstack/react-query";
import { IMAGE_KEYS } from "./image.keys";
import { imageServices } from "./image.services";

export const useCreateImage = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: imageServices.createImage,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: IMAGE_KEYS.lists(),
      });
    },
  });
};

export const useUpdateImage = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: imageServices.updateImage,
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: IMAGE_KEYS.detail(variables.id),
      });
      queryClient.invalidateQueries({
        queryKey: IMAGE_KEYS.lists(),
      });
    },
  });
};

export const useDeleteImage = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: imageServices.deleteImage,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: IMAGE_KEYS.lists(),
      });
    },
  });
};

export const useCreateImages = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: imageServices.createImages,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: IMAGE_KEYS.lists(),
      });
    },
  });
};
